/*
  Origins share popup.

  Bound with document-level delegation on purpose: the quick-view modal builds
  its contents with innerHTML, and inline <script> tags never execute when HTML
  is injected that way. Delegation means one listener, loaded once, that also
  covers markup added to the page later.
*/
(function () {
  if (window.__originsShareBound) return;
  window.__originsShareBound = true;

  var NETWORKS = [
    { key: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/sharer/sharer.php?u={url}' },
    { key: 'x', label: 'X', url: 'https://twitter.com/intent/tweet?url={url}&text={title}' },
    { key: 'email', label: 'Email', url: 'mailto:?subject={title}&body={url}' },
    { key: 'pinterest', label: 'Pinterest', url: 'https://pinterest.com/pin/create/button/?url={url}&description={title}' },
    { key: 'tumblr', label: 'Tumblr', url: 'https://www.tumblr.com/share/link?url={url}&name={title}' },
    { key: 'telegram', label: 'Telegram', url: 'https://t.me/share/url?url={url}&text={title}' },
    { key: 'whatsapp', label: 'WhatsApp', url: 'https://api.whatsapp.com/send?text={title}%20{url}' }
  ];

  // Brand marks come from the <template> the layout renders, so the SVG data
  // lives in the theme's icon assets rather than being duplicated here.
  function iconFor(key) {
    var tpl = document.getElementById('origins-share-icons');
    if (tpl) {
      var node = tpl.content.querySelector('[data-key="' + key + '"]');
      if (node) return node.innerHTML;
    }
    return '';
  }

  function close() {
    var open = document.querySelector('.origins-share-overlay');
    if (open) open.remove();
    document.documentElement.classList.remove('origins-share-open');
  }

  function open(shareUrl, shareTitle) {
    close();
    var u = encodeURIComponent(shareUrl);
    var t = encodeURIComponent(shareTitle || document.title);

    var overlay = document.createElement('div');
    overlay.className = 'origins-share-overlay';
    overlay.innerHTML =
      '<div class="origins-share-card" role="dialog" aria-modal="true" aria-label="Share this product">' +
        '<button type="button" class="origins-share-x" data-share-close aria-label="Close">&times;</button>' +
        '<p class="origins-share-heading">Copy link</p>' +
        '<div class="origins-share-copy">' +
          '<input type="text" readonly value="' + shareUrl.replace(/"/g, '&quot;') + '" data-share-url>' +
          '<button type="button" data-share-copy aria-label="Copy link">Copy</button>' +
        '</div>' +
        '<div class="origins-share-nets">' +
          NETWORKS.map(function (n) {
            return '<a class="origins-share-net origins-share-net--' + n.key + '" target="_blank" rel="noopener" ' +
              'title="' + n.label + '" aria-label="Share on ' + n.label + '" ' +
              'href="' + n.url.replace('{url}', u).replace('{title}', t) + '">' +
              (iconFor(n.key) || '<span>' + n.label.charAt(0) + '</span>') + '</a>';
          }).join('') +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    document.documentElement.classList.add('origins-share-open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-origins-share]');
    if (trigger) {
      e.preventDefault();
      open(trigger.getAttribute('data-share-url') || window.location.href,
           trigger.getAttribute('data-share-title') || document.title);
      return;
    }

    if (e.target.closest('[data-share-close]') ||
        (e.target.classList && e.target.classList.contains('origins-share-overlay'))) {
      close();
      return;
    }

    var copy = e.target.closest('[data-share-copy]');
    if (copy) {
      var input = copy.parentNode.querySelector('[data-share-url]');
      if (!input) return;
      input.select();
      var done = function () {
        copy.textContent = 'Copied';
        setTimeout(function () { copy.textContent = 'Copy'; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(input.value).then(done, function () {
          try { document.execCommand('copy'); done(); } catch (err) { /* nothing to do */ }
        });
      } else {
        try { document.execCommand('copy'); done(); } catch (err) { /* nothing to do */ }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
